import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_ORIG_API

export function comRequest(method, templateName, obj) {
  let url = urlPrefix + '/' + templateName;
  if (method === 'post') {
    obj.id = null;
    return request({
      url: url,
      method: 'post',
      data: obj
    })
  } else if (method === 'get') {
    return request({
      url: url + "/" + obj,
      method: 'get',
    })
  } else if (method === 'put') {
    return request({
      url: url + "/" + obj.id,
      method: 'put',
      data: obj
    })
  } else if (method === 'delete') {
    return request({
      url: url + "/" + obj,
      method: 'delete'
    })
  } else if (method === 'page') {
    return request({
      url: url + "/list-page",
      method: 'post',
      data: obj
    })
  } else if (method === 'getSort') {
    return request({
      url: url + "/sort",
      method: 'get',
    })
  }
  else {
    return request({
      url: url + "/" + method,
      method: 'post',
      data: obj
    })
  }
  console.log("类型错误");
}

//查询客户信息
export function getBspAndBizCusInfoByBspId(obj) {
  return request({
    url: urlPrefix + '/orig-cus/cus',
    method: 'get',
    params: obj
  })
}
//分页查询审批列表
export function getCusBargainList(obj) {
  return request({
    url: urlPrefix + '/cus-bargain/cus-bargain-listpage',
    method: 'post',
    data: obj,
  });
}
//下载客户合同文本
export function downloadBargainFile(obj) {
  return request({
    url: urlPrefix + '/cus-bargain/download-bargain-txt',
    method: 'post',
    data: obj,
  });
}
//根据客户ID查询合同编号
export function getbargaincodebycusid(obj) {
  return request({
    url: urlPrefix + '/cus-bargain/bargain-code',
    method: 'get',
    params: obj
  })
}












